export const reloadApp = () => {
  window.location.href = window.location.origin;
};
